(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-complimentary"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", (event) => {
    const productRecommendationsSection = document.querySelector('.product-complimentary');
    if (! productRecommendationsSection) return;
    


    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      


      observer.unobserve(productRecommendationsSection);

      const url = productRecommendationsSection.dataset.url;

      fetch(url).then(response => response.text()).then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-complimentary');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }

        const addToCartForms = document.querySelectorAll('.complementary-form');

        if (addToCartForms && addToCartForms.length) {
          addToCartForms.forEach(item => {
            item.addEventListener('submit', function(event) {
              event.preventDefault();

              let formData = new FormData(item);

              fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                body: formData
              }).then(response => {
                return response.json();
              }).then(() => {

                fetch("/cart.json").then((response) => response.json()).then((cart) => {

                  document.querySelectorAll(".CartCount").forEach(function(el) {
                    el.innerText = cart.item_count;
                    el.classList.remove('hidden');
                  });

                  document.querySelector('.site-header__cart').click();

                });

              }).catch((error) => {
                console.error('Error:', error);
              });

            });
          });
        }
      }).catch(e => {
        console.error(e);
      });
    };

    const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
    observer.observe(productRecommendationsSection);
  });
  } catch(e) { console.error(e); }
})();

})();
